import http from '../versa/http.js';

// Script set-api-host.ps1 atualiza API_BASE; '' = same-origin quando servido pela API
const API_BASE = 'https://sessp.sialwms.com.br';
const AGENT_URL = 'http://localhost:9101';
const HOST = (typeof window !== 'undefined' && window.location.port === '8001') ? '' : API_BASE;
//const HOST = 'http://localhost:8000';	// Dev docker-compose
//const HOST = 'http://localhost:8000';		// Prod

/** Base da API (mesma regra do HOST interno) — para fetch direto sem msgbox, ex. banner da Central. */
export function getSialApiHost()
{
	return HOST;
}

const API = {

	call: http,

	// AUTH

	async auth(username, password)
	{
		let endpoint = `${HOST}/auth`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: `username=${username}&password=${password}`
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async request_password(data)
	{
		let endpoint = `${HOST}/auth/requests`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async reset_password(data)
	{
		let endpoint = `${HOST}/auth/resets`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// ENDPOINTS

	async list_endpoints(query = '')
	{
		let endpoint = `${HOST}/endpoints${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_endpoint(data)
	{
		let endpoint = `${HOST}/endpoints`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_endpoint(endpoint_id, data)
	{
		let endpoint = `${HOST}/endpoints/${endpoint_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_endpoint(endpoint_id)
	{
		let endpoint = `${HOST}/endpoints/${endpoint_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_endpoint(endpoint_id)
	{
		let endpoint = `${HOST}/endpoints/${endpoint_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// GROUPS

	async list_groups(query = '')
	{
		let endpoint = `${HOST}/groups${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_group(data)
	{
		let endpoint = `${HOST}/groups`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_group(group_id, data)
	{
		let endpoint = `${HOST}/groups/${group_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_group(group_id)
	{
		let endpoint = `${HOST}/groups/${group_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_group(group_id)
	{
		let endpoint = `${HOST}/groups/${group_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// USERS

	async list_users(query = '')
	{
		let endpoint = `${HOST}/users${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_user(data)
	{
		let endpoint = `${HOST}/users`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_user(user_id, data)
	{
		let endpoint = `${HOST}/users/${user_id}`;
		let options = { 
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_user(user_id)
	{
		let endpoint = `${HOST}/users/${user_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_user(user_id)
	{
		let endpoint = `${HOST}/users/${user_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// LOGS

	async list_logs(query = '')
	{
		let endpoint = `${HOST}/logs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_log(log_id)
	{
		let endpoint = `${HOST}/logs/${log_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// INTEGRATION EVENTS (Central de integrações #MT-6531173)

	async list_integration_events(query = '')
	{
		let endpoint = `${HOST}/integration-events${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_integration_event(integration_event_id)
	{
		let endpoint = `${HOST}/integration-events/${integration_event_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_integration_event(data)
	{
		let endpoint = `${HOST}/integration-events`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async integration_events_summary(hours = 24, stale_minutes = 12)
	{
		let endpoint = `${HOST}/integration-events/summary?hours=${encodeURIComponent(hours)}&stale_minutes=${encodeURIComponent(stale_minutes)}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async get_integration_events_techhub_inbox_debug(inbox_id)
	{
		let endpoint = `${HOST}/integration-events/techhub-inbox/${encodeURIComponent(inbox_id)}/debug`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/**
	 * @param {number} limit — lote automático (cron) quando não há inbox_ids
	 * @param {null|{ inbox_ids?: number[], inbox_id?: number }} extra — UI: { inbox_ids: [1,2] } ou legado { inbox_id: 742 }
	 */
	async post_integration_events_techhub_process(limit = 200, extra = null)
	{
		let q = `limit=${encodeURIComponent(limit)}`;
		const ex = extra && typeof extra === 'object' ? extra : {};
		if (ex.inbox_id != null && ex.inbox_id !== '')
			q += `&inbox_id=${encodeURIComponent(ex.inbox_id)}`;
		let endpoint = `${HOST}/integration-events/techhub-process?${q}`;
		const ids = Array.isArray(ex.inbox_ids) ? ex.inbox_ids.filter((n) => n != null && String(n).trim() !== '') : [];
		const useBody = ids.length > 0;
		let options = {
			method: 'POST',
			credentials: 'include',
			headers: useBody ? { 'Content-Type': 'application/json' } : {},
			body: useBody ? JSON.stringify({ inbox_ids: ids.map((n) => parseInt(String(n), 10)).filter((n) => !Number.isNaN(n)) }) : undefined,
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async post_integration_events_techhub_flush_status(limit = 200)
	{
		let endpoint = `${HOST}/integration-events/techhub-flush-status?limit=${encodeURIComponent(limit)}`;
		let options = { method: 'POST', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async post_integration_events_techhub_pull(body = {})
	{
		let endpoint = `${HOST}/integration-events/techhub-pull`;
		let options = {
			method: 'POST',
			body: JSON.stringify(body && typeof body === 'object' ? body : {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async get_integration_events_techhub_runtime_config()
	{
		let endpoint = `${HOST}/integration-events/techhub-runtime-config`;
		let response = await fetch(endpoint, { method: 'GET', credentials: 'include' });
		return response;
	},

	async put_integration_events_techhub_runtime_config(portal_enabled)
	{
		let endpoint = `${HOST}/integration-events/techhub-runtime-config`;
		let options = {
			method: 'PUT',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ portal_enabled: !!portal_enabled }),
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async post_integration_events_techhub_list_integrated(body = {})
	{
		let endpoint = `${HOST}/integration-events/techhub-list-integrated`;
		let options = {
			method: 'POST',
			body: JSON.stringify(body && typeof body === 'object' ? body : {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// CITIES

	async list_cities(query = '')
	{
		let endpoint = `${HOST}/cities${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// COMPANIES

	async list_all_companies(query = '')
	{
		let endpoint = `${HOST}/companies/all${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_companies(query = '')
	{
		let endpoint = `${HOST}/companies${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_company(data)
	{
		let endpoint = `${HOST}/companies`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_company(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// UNITS

	async list_units(query = '')
	{
		let endpoint = `${HOST}/units${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_unit(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/units`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_unit(company_id, unit_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/units/${unit_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_unit(company_id, unit_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/units/${unit_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_unit(company_id, unit_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/units/${unit_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CLASSES

	async list_classes(query = '')
	{
		let endpoint = `${HOST}/classes${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_class(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/classes`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_class(company_id, class_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/classes/${class_id}`;
		let options = {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_class(company_id, class_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/classes/${class_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_class(company_id, class_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/classes/${class_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_class(company_id, class_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/classes/${class_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CATEGORIES
	
	async list_categories(query = '')
	{
		let endpoint = `${HOST}/categories${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_category(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/categories`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_category(company_id, category_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/categories/${category_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_category(company_id, category_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/categories/${category_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_category(company_id, category_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/categories/${category_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// MANUFACTURERS
	
	async list_manufacturers(query = '')
	{
		let endpoint = `${HOST}/manufacturers${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_manufacturer(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/manufacturers`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_manufacturer(company_id, manufacturer_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_manufacturer(company_id, manufacturer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_manufacturer(company_id, manufacturer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// PRODUCTS

	async list_products(query = '')
	{
		let endpoint = `${HOST}/products${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_product(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/products`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_product(company_id, product_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_product(company_id, product_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}`;
		let options = { 
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_product(company_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_product(company_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// PRODUCT PACKAGINGS

	async list_product_packagings(query = '')
	{
		// Sob /companies/… para ambientes em que nginx só proxeia prefixos já listados (ex.: AWS QA sem /packagings).
		let endpoint = `${HOST}/companies/packagings${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_product_packagings_by_product(company_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}/packagings`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** Conferência / coletor: GTIN cadastrado na embalagem → registro da embalagem (incl. product_id). */
	async resolve_packaging_gtin(company_id, gtin)
	{
		const q = new URLSearchParams({ gtin: String(gtin || '').trim() });
		let endpoint = `${HOST}/companies/${company_id}/packagings/resolve-gtin?${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_product_packaging(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/packagings`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_product_packaging(company_id, packaging_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/packagings/${packaging_id}`;
		let options = {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_product_packaging(company_id, packaging_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/packagings/${packaging_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_product_packaging(company_id, packaging_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/packagings/${packaging_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_product_packaging(company_id, packaging_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/packagings/${packaging_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// WAREHOUSES

	async list_warehouses(query = '')
	{
		let endpoint = `${HOST}/warehouses${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_warehouse(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_warehouse(company_id, warehouse_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_warehouse(company_id, warehouse_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_warehouse(company_id, warehouse_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// LOCATIONS

	async list_locations(query = '')
	{
		let endpoint = `${HOST}/locations${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_location_labels(data)
	{
		let endpoint = `${HOST}/locations/print-labels`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_location(company_id, warehouse_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_location(company_id, warehouse_id, location_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_location(company_id, warehouse_id, location_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_location(company_id, warehouse_id, location_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// PAYMENT TERMS

	async list_payment_terms(query = '')
	{
		let endpoint = `${HOST}/payment-terms${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_payment_term(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/payment-terms`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_payment_term(company_id, payment_term_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_payment_term(company_id, payment_term_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_payment_term(company_id, payment_term_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// PRICE LISTS

	async list_price_lists(query = '')
	{
		let endpoint = `${HOST}/price-lists${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_price_list(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/price-lists`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_price_list(company_id, price_list_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/price-lists/${price_list_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_price_list(company_id, price_list_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/price-lists/${price_list_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_price_list(company_id, price_list_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/price-lists/${price_list_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// SUPPLIERS

	async list_suppliers(query = '')
	{
		let endpoint = `${HOST}/suppliers${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_supplier(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/suppliers`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_supplier(company_id, supplier_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/suppliers/${supplier_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_supplier(company_id, supplier_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/suppliers/${supplier_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_supplier(company_id, supplier_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/suppliers/${supplier_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CUSTOMERS

	async list_customers(query = '')
	{
		let endpoint = `${HOST}/customers${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async count_customers_report(data)
	{
		let endpoint = `${HOST}/customers/count-report`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_customers_report(data)
	{
		let endpoint = `${HOST}/customers/print-report`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_customer(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_customer(company_id, customer_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_customer(company_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_customer(company_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CUSTOMER PRICES (tabela de preço por cliente)

	async customer_prices_template(company_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/customer-prices/template`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_prices_import(company_id, customer_id, csv_content)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/customer-prices/import`;
		let options = {
			method: 'POST',
			body: JSON.stringify({ csv: csv_content }),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_prices_summary(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-prices-summary`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_prices_list(company_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_prices_replace(company_id, customer_id, prices)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
		let options = {
			method: 'PUT',
			body: JSON.stringify({ prices }),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_prices_delete(company_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_price_get(company_id, customer_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/price?product_id=${product_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CARRIERS

	async list_carriers(query = '')
	{
		let endpoint = `${HOST}/carriers${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_carrier(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/carriers`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_carrier(company_id, carrier_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/carriers/${carrier_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_carrier(company_id, carrier_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/carriers/${carrier_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_carrier(company_id, carrier_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/carriers/${carrier_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// DEVICES

	async list_devices(query = '')
	{
		let endpoint = `${HOST}/devices${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_device(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/devices`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_device(company_id, device_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/devices/${device_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_device(company_id, device_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/devices/${device_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_device(company_id, device_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/devices/${device_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CFOPS

	async list_cfops(query = '')
	{
		let endpoint = `${HOST}/cfops${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_cfop(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/cfops`;
		let options = { method: 'POST', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_cfop(company_id, cfop_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/cfops/${cfop_id}`;
		let options = { method: 'PUT', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_cfop(company_id, cfop_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/cfops/${cfop_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_cfop(company_id, cfop_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/cfops/${cfop_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_cfops_by_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/cfops`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// PROGRAMS

	async list_programs(query = '')
	{
		let endpoint = `${HOST}/programs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_programs_by_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/programs`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_program(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/programs`;
		let options = { method: 'POST', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_program(company_id, program_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/programs/${program_id}`;
		let options = { method: 'PUT', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_program(company_id, program_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/programs/${program_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_program(company_id, program_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/programs/${program_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// RECEIPT TYPES (tipo de recebimento — pedido de entrada)

	async list_receipt_types(query = '')
	{
		// Sob /companies/… para ambientes em que nginx só proxeia prefixos já listados (ex.: AWS QA sem /receipt-types).
		let endpoint = `${HOST}/companies/receipt-types${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_receipt_types_by_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/receipt-types`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_receipt_type(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/receipt-types`;
		let options = { method: 'POST', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_receipt_type(company_id, receipt_type_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
		let options = { method: 'PUT', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_receipt_type(company_id, receipt_type_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_receipt_type(company_id, receipt_type_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// INPUT ORDERS

	async list_input_orders(query = '')
	{
		// Sob /companies/… para nginx AWS que só proxeia esse prefixo (mesmo padrão de receipt-types / packagings).
		let endpoint = `${HOST}/companies/input-orders${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_input_order(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_input_order(company_id, input_order_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/${input_order_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_input_order(company_id, input_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/${input_order_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_input_order(company_id, input_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/${input_order_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_pending_input_items(company_id, input_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/${input_order_id}/pending`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_order_document(data)
	{
		let endpoint = `${HOST}/input-orders/print-order-document`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// INPUTS

	async list_inputs(query = '')
	{
		let endpoint = `${HOST}/inputs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_input(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_input(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_input(company_id, input_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_input(company_id, input_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async inventory_input(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/inventory`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async putaway_input(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/putaway`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async reverse_input(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/reverse`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_inputs(data)
	{
		let endpoint = `${HOST}/inputs/print-list`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_skus(data)
	{
		let endpoint = `${HOST}/inputs/print-skus`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_xml(data)
	{
		let endpoint = `${HOST}/inputs/print-xml`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_putaway(data)
	{
		let endpoint = `${HOST}/inputs/print-putaway`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_costs(data)
	{
		let endpoint = `${HOST}/inputs/print-costs`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_conference(data)
	{
		let endpoint = `${HOST}/inputs/print-conference`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_details(data)
	{
		let endpoint = `${HOST}/inputs/print-details`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async count_inputs_complete_report(data)
	{
		let endpoint = `${HOST}/inputs/print-complete/count`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_inputs_complete_report(data)
	{
		let endpoint = `${HOST}/inputs/print-complete`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_labels(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/print-labels`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async import_xml(data)
	{
		let endpoint = `${HOST}/inputs/import-xml`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// LOTS

	async list_lots(query = '')
	{
		let endpoint = `${HOST}/lots${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_lot(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/lots`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_lot(company_id, lot_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/lots/${lot_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_lot(company_id, lot_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/lots/${lot_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_lot(company_id, lot_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/lots/${lot_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// OUTPUT ORDERS

	async list_output_orders(query = '')
	{
		let endpoint = `${HOST}/output-orders${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_output_order(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_output_order(company_id, output_order_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_output_order(company_id, output_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_output_order(company_id, output_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_pending_output_items(company_id, output_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}/pending`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_pending_output_orders(data)
	{
		let endpoint = `${HOST}/output-orders/print-pending`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_output_order_document(data)
	{
		let endpoint = `${HOST}/output-orders/print-order-document`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async upload_output_order(company_id, formData)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/upload`;
		let options = { method: 'POST', body: formData, credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async upload_input_order(company_id, formData)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/upload`;
		let options = { method: 'POST', body: formData, credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async order_upload_template(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/order-upload/template`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// OUTPUTS

	async list_outputs(query = '')
	{
		let endpoint = `${HOST}/outputs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_output(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_output(company_id, output_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_output(company_id, output_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_output(company_id, output_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async create_outputs(data)
	{
		let endpoint = `${HOST}/outputs/create`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async close_outputs(data)
	{
		let endpoint = `${HOST}/outputs/close`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async cancel_outputs(data)
	{
		let endpoint = `${HOST}/outputs/cancel`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async reverse_output(company_id, output_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/reverse`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_output_volumes(data)
	{
		let endpoint = `${HOST}/outputs/list-volumes`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_pick_control(data)
	{
		let endpoint = `${HOST}/outputs/print-pick-control`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_pallets_overturn(data)
	{
		let endpoint = `${HOST}/outputs/print-pallets-overturn`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_picklists(data)
	{
		let endpoint = `${HOST}/outputs/print-picklists`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_aviso_remessa(data)
	{
		let endpoint = `${HOST}/outputs/print-aviso-remessa`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_conference(data)
	{
		let endpoint = `${HOST}/outputs/print-conference`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_output_labels(data)
	{
		let endpoint = `${HOST}/outputs/print-labels`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async sendZplToAgent(zpl, printer, printerKey)
	{
		const hasKey = printerKey != null && String(printerKey).trim() !== '';
		const hasPrinterAddr =
			printer &&
			typeof printer === 'object' &&
			String(printer.address || '').trim() !== '';
		if (!hasKey && !hasPrinterAddr)
		{
			throw new Error(
				'A API não retornou impressora (printer_key nem IP). Marque "Usar agente local" e escolha a impressora na lista, ' +
				'ou ajuste o cadastro de Dispositivos. Sem isso o agente usa só [printers] default no config.ini (risco de imprimir na impressora errada).'
			);
		}
		const endpoint = `${AGENT_URL}/print`;
		const payload = { zpl };
		if (hasKey)
			payload.printer_key = String(printerKey).trim();
		if (printer && typeof printer === 'object')
			payload.printer = printer;
		const options = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload)
		};
		let response;
		try {
			response = await fetch(endpoint, options);
		} catch (e) {
			const msg = e && e.message ? String(e.message) : String(e);
			const netFail = /Failed to fetch|NetworkError|network|load failed|fetch/i.test(msg);
			throw new Error(
				netFail
					? `Print Agent não responde em ${AGENT_URL}. Neste PC, inicie o agente (pasta do print-agent: INICIAR.bat ou launch-print-agent.vbs) e tente de novo.`
					: `Falha ao contatar o Print Agent (${AGENT_URL}): ${msg}`
			);
		}
		if (!response.ok) {
			const text = await response.text();
			throw new Error(text || `Agente local (${AGENT_URL}) retornou ${response.status}. Verifique se o agente está rodando.`);
		}
		return response;
	},

	// STOCKS

	async list_stocks(query = '')
	{
		let endpoint = `${HOST}/stocks${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_stock(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/stocks`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_stock(company_id, stock_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/stocks/${stock_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_stock(company_id, stock_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/stocks/${stock_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_stock(company_id, stock_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/stocks/${stock_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_stocks_by_input(company_id, input_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/stocks`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_stocks_by_product(company_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}/stocks`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async move_stock(company_id, lot_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/lots/${lot_id}/move`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_stocks_by_sku(data)
	{
		let endpoint = `${HOST}/stocks/print-by-sku`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_stocks_by_lot(data)
	{
		let endpoint = `${HOST}/stocks/print-by-lot`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_stocks_by_location(data)
	{
		let endpoint = `${HOST}/stocks/print-by-location`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_lot_labels(data)
	{
		let endpoint = `${HOST}/stocks/print-lot-labels`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async export_stocks_csv(data)
	{
		let endpoint = `${HOST}/stocks/export`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// REPLENISHMENTS

	async list_replenishments(query = '')
	{
		let endpoint = `${HOST}/replenishments${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_replenishment(company_id, warehouse_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_replenishment(company_id, warehouse_id, replenishment_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_replenishment(company_id, warehouse_id, replenishment_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_replenishment(company_id, warehouse_id, replenishment_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async close_replenishments(data)
	{
		let endpoint = `${HOST}/replenishments/close`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_replenishment_orders(data)
	{
		let endpoint = `${HOST}/replenishments/print-orders`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// INVENTORIES

	async list_inventories(query = '')
	{
		let endpoint = `${HOST}/inventories${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_inventory(company_id, warehouse_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_inventory(company_id, warehouse_id, inventory_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_inventory(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_inventory(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async check_inventory_item(company_id, warehouse_id, inventory_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/items`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async cancel_inventory(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/cancel`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async close_inventory(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/close`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_inventory_pending(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/print-pending`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_inventory_deviation(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/print-deviation`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// TRANSACTIONS

	async list_transactions(query = '')
	{
		let endpoint = `${HOST}/transactions${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_transaction(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/transactions`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_transaction(company_id, transaction_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/transactions/${transaction_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_transaction(company_id, transaction_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/transactions/${transaction_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_transaction(company_id, transaction_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/transactions/${transaction_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// BI — KARDEX (#MT-1DB4950)
	// Query: product_id, date_from, date_to, lot_id?, cost_mode?, include_disabled?, limit?, offset?
	async kardex_report(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/kardex${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async kardex_summary(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/kardex/summary${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** Kardex analítico PDF ou CSV — body: product_id, date_from, date_to, lot_id?, cost_mode?, include_disabled?, format: pdf|csv */
	async print_kardex(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/reports/kardex/print`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// INVOICES

	async list_invoices(query = '')
	{
		let endpoint = `${HOST}/invoices${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_invoice(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoices`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_invoice(company_id, invoice_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoices/${invoice_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_invoice(company_id, invoice_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoices/${invoice_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_invoice(company_id, invoice_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoices/${invoice_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async create_invoices(data)
	{
		let endpoint = `${HOST}/invoices/create`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_invoices_xml(data)
	{
		let endpoint = `${HOST}/invoices/update-xml`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async create_archive(data)
	{
		let endpoint = `${HOST}/invoices/archive`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async inutilizar_invoices(data)
	{
		let endpoint = `${HOST}/invoices/inutilizar`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_iqvia(data)
	{
		let endpoint = `${HOST}/invoices/print-iqvia`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// INVOICE LOTS

	async list_invoice_lots(query = '')
	{
		let endpoint = `${HOST}/invoice-lots${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_invoice_lot(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoice-lots`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_invoice_lot(company_id, invoice_lot_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_invoice_lot(company_id, invoice_lot_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_invoice_lot(company_id, invoice_lot_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async create_invoice_lots(data)
	{
		let endpoint = `${HOST}/invoice-lots/create`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async send_invoice_lots(data)
	{
		let endpoint = `${HOST}/invoice-lots/send`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async query_invoice_lots(data)
	{
		let endpoint = `${HOST}/invoice-lots/query`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// VERSION
	
	async version()
	{
		let endpoint = `${HOST}/version`;
		let response = await fetch(endpoint);
		return response;
	},

	// CENTRAL DE IMPORTAÇÃO

	async import_center_entities()
	{
		let endpoint = `${HOST}/import-center/entities`;
		let options = { method: 'GET', credentials: 'include' };
		return fetch(endpoint, options);
	},

	async import_center_validate(formData)
	{
		let endpoint = `${HOST}/import-center/validate`;
		let options = { method: 'POST', body: formData, credentials: 'include' };
		return fetch(endpoint, options);
	},

	async import_center_import(data)
	{
		let endpoint = `${HOST}/import-center/import`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		return fetch(endpoint, options);
	},

	async import_center_template(entity_key)
	{
		let endpoint = `${HOST}/import-center/template/${entity_key}`;
		let options = { method: 'GET', credentials: 'include' };
		return fetch(endpoint, options);
	},

}

export default API;

